import React from 'react';
import { HexColorPicker } from 'react-colorful';
import { Box } from '@mui/material';
import { useStyling } from '../Theme';
import { C, H } from '../Layout';
import FormWidget from '../form/FormWidget';

export type Swatch = { key: string; color: string };

export default function LexicalColorPicker({
    value,
    onChange,
    swatches = [],
    width = 220,
    pickerHeight = 120,
    showHex = true
}: {
    value: string;
    onChange: (hex: string) => void;
    swatches?: Swatch[];
    width?: number | string;
    pickerHeight?: number | string;
    showHex?: boolean;
}) {
    const { theme } = useStyling();

    return (
        // leaving this as <Box because V creates to many re renders and an infinite loop
        <Box sx={{ p: 1.5, width, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <C
                sx={{
                    height: pickerHeight,
                    width: '100%',
                    '& .react-colorful__pointer': { width: 18, height: 18 },
                    '& .react-colorful__pointer.react-colorful__hue-pointer': {
                        width: 15,
                        height: 28,
                        borderRadius: '4px'
                    },
                    '& .react-colorful *': { outline: 'none' },
                    '& .react-colorful__saturation': { borderRadius: 0 },
                    '& .react-colorful__last-control': { borderRadius: 0 }
                }}
            >
                <HexColorPicker
                    color={value}
                    onChange={onChange}
                    style={{ width: '100%', height: '100%', borderRadius: 0 }}
                />
            </C>

            <H sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {swatches.map((s) => (
                    <C
                        key={s.key}
                        onClick={() => onChange(s.color)}
                        sx={{
                            width: 16,
                            height: 16,
                            borderRadius: '2px',
                            backgroundColor: s.color,
                            cursor: 'pointer',
                            transition: 'box-shadow 0.2s, border 0.2s',
                            border:
                                s.color.toLowerCase() === theme.palette.common.white.toLowerCase()
                                    ? `1px solid ${theme.palette.divider}`
                                    : 'none'
                        }}
                    />
                ))}
            </H>

            {showHex ? (
                <FormWidget name="colorHex" sx={{ mt: 0.5 }} readOnly value={value} onChange={() => {}} />
            ) : null}
        </Box>
    );
}
